<template>
  <div class="stall-wrapper">
    <div class="stall-list">
      <empty
        v-if="isEmpty && !isLoading"
        :desc="'您还未创建档口类型'"
        :type="1"
        :img="'Empty'"
        class="empty-box"
      ></empty>
      <template v-if="!isLoading && !isEmpty">
        <div v-for="stall in stallList" :key="stall.stallId" class="stall-item">
          <div class="name">{{ stall.stallName }}</div>
          <div class="edit-wrappr">
            <div class="edit" @click="goEdit(stall)">修改</div>
            <div class="edit" @click="deleteStall(stall)">删除</div>
          </div>
        </div>
      </template>
    </div>
    <div class="add-btn">
      <div class="btn" @click="addStall">新建档口类型</div>
    </div>
  </div>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import Empty from '@/common/layout/empty/index'
import { API } from '@/api'
export default {
  components: {
    Empty
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const title = '档口类型'
      navBar.setTitle({
        text: title
      })
      document.title = title
      vm.getStallList()
    })
  },
  data() {
    return {
      stallList: [],
      isLoading: true
    }
  },
  computed: {
    isEmpty() {
      return this.stallList.length === 0
    }
  },
  methods: {
    async getStallList() {
      try {
        const res = await API.account.configGetByKey({ key: 'stall' })
        this.stallList = res.stalls || []
        this.isLoading = false
      } catch (error) {
        this.$catch(error)
      }
    },
    goEdit(stall) {
      this.$router.push({
        name: 'stallEdit',
        query: {
          stallId: stall.stallId,
          stallName: stall.stallName,
          type: 2
        }
      })
    },
    async deleteStall(stall) {
      try {
        await API.account.configOperate({
          key: 'stall',
          type: 3, // 1添加、2修改、3删除
          id: stall.stallId // 修改或删除的时候传，档口id
        })
        this.$toast('删除成功')
        this.getStallList()
      } catch (error) {
        this.$catch(error)
      }
    },
    addStall() {
      this.$router.push({
        name: 'stallEdit',
        query: {
          type: 1
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.stall-wrapper {
  height: 100vh;
  padding-top: 8px;
  box-sizing: border-box;
  overflow: hidden;

  background-color: #f5f5f5;

  @include flex-column;
  .stall-list {
    flex: auto;
    height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    .stall-item {
      height: 0.96rem /* 48/50 */;
      padding: 0 18px 0 32px;
      background-color: #fff;
      @include flex-row-between;
      .name {
        flex: auto;
        width: 0;
      }
      .edit-wrappr {
        @include flex-row-center;
        .edit {
          width: 0.96rem /* 48/50 */;
          height: 0.48rem /* 24/50 */;
          border: 1px solid #0daf52;
          border-radius: 0.8rem;
          margin-right: 0.24rem /* 12/50 */;
          @include text(0.24rem /* 12/50 */, #0daf52);
          @include flex-row-center;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .tip {
      padding-top: 0.32rem /* 16/50 */;
      text-align: center;
      @include text(0.24rem /* 12/50 */, #8c8c8c);
    }
  }
  .add-btn {
    width: 100vw;
    background-color: #fff;
    @include iphonex-padding-bottom(6px);
    @include flex-row-center;
    .btn {
      width: 6.5rem /* 325/50 */;
      height: 0.88rem /* 44/50 */;
      border-radius: 0.8rem /* 40/50 */;
      background-color: #15bb5c;
      @include flex-row-center;
      @include text(0.32rem, #fff);
    }
  }
}
.empty-box {
  position: relative;

  height: 100%;
}
</style>
